<template>
  <PrmIconField icon-position="left">
    <PrmInputIcon style="line-height: 1rem;">
      <i class="pi pi-search" />
    </PrmInputIcon>
    <PrmInputText
      :model-value="modelValue"
      :disabled="disabled"
      :loading="loading"
      :placeholder="placeholder || t('common.search')"
      style="width: 100%"
      @update:model-value="emit('update:modelValue', $event as string)"
    />
  </PrmIconField>
</template>

<script setup lang="ts">
import PrmIconField from '@NitrexGroup/primevue/iconfield';
import PrmInputIcon from '@NitrexGroup/primevue/inputicon';
import PrmInputText from '@NitrexGroup/primevue/inputtext';

import useLibraryI18n from '../../i18n/composable.ts';

defineProps<{
  modelValue?: string | null,
  loading?: boolean,
  disabled?: boolean,
  invalid?: boolean,
  readonly?: boolean,
  placeholder?: string,
}>();

const emit = defineEmits<{
  (e: 'update:modelValue', value: string): void,
}>();

const {
  t,
} = useLibraryI18n();
</script>
